import axios from 'axios';
import cookies from 'js-cookie';
import { cookieNames } from '~constants/storage';
import { bookingsActionTypes as actions } from '~client/constants/actionTypes';
import { fetch, updateCommunicationStatus, handleFetchCatch } from '~actions/shared';
import * as queries from '~settings/queries';
import endpoints from '~settings/endpoints';
import { formatSimpleParams } from '~helpers';
import { communicationStatus, pbsaStatusTabs } from '~constants';

export const updateLandlordBookingStatus =
  (params = {}) =>
  dispatch => {
    fetch({
      endpoint: endpoints.graphql.url(),
      communicationType: actions.UPDATE_BOOKING_STATUS_CS,
      params: queries.updateLandlordBookingStatus(
        formatSimpleParams(
          {
            bookingIds: [],
            status: '',
          },
          params,
        ),
      ),
      dispatch,
    });
  };

export const createBookingComment =
  (params = {}) =>
  dispatch => {
    const communicationType = actions.CREATE_BOOKING_COMMENT_CS;

    dispatch(
      updateCommunicationStatus({
        actionType: communicationType,
        status: communicationStatus.FETCHING,
      }),
    );

    axios({
      method: 'post',
      url: endpoints.graphql.url(),
      data: queries.createBookingComment(
        formatSimpleParams(
          {
            bookingId: null,
            content: '',
          },
          params,
        ),
      ),
      headers: {
        Authorization: cookies.get(cookieNames.token)
          ? `Bearer ${cookies.get(cookieNames.token)}`
          : '',
        'Current-Role': 'landlord',
      },
    })
      .then(response => {
        if (response.data.data && response.data.errors) {
          dispatch(
            updateCommunicationStatus({
              actionType: communicationType,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        } else if (typeof response.data.errors === 'undefined' && response.data.data) {
          dispatch(
            updateLandlordBookingStatus({
              bookingIds: [params.bookingId],
              status: pbsaStatusTabs.pendingApproval.toUpperCase(),
            }),
          );
          dispatch(
            updateCommunicationStatus({
              actionType: communicationType,
              status: communicationStatus.IDLE,
            }),
          );
        } else {
          dispatch(
            updateCommunicationStatus({
              actionType: communicationType,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        }
      })
      .catch(error => {
        handleFetchCatch({
          actionType: communicationType,
          dispatch,
          error,
        });
      });
  };

export const batchUpdateLandlordBookingStatus =
  (params = {}) =>
  dispatch => {
    fetch({
      endpoint: endpoints.graphql.url(),
      communicationType: actions.BATCH_UPDATE_BOOKING_STATUS_CS,
      params: queries.batchUpdateLandlordBookingStatus(
        formatSimpleParams(
          {
            landlordBookingStatus: '',
            propertyNodeId: null,
            createdAfter: null,
            createdBefore: null,
          },
          params,
        ),
      ),
      dispatch,
    });
  };

export const initBookingCommunicationStatus = () => dispatch => {
  dispatch(
    updateCommunicationStatus({
      actionType: actions.SET_BOOKINGS_REJECT_CS,
      status: communicationStatus.IDLE,
    }),
  );
  dispatch(
    updateCommunicationStatus({
      actionType: actions.UPDATE_BOOKINGS_CONFIRM_CS,
      status: communicationStatus.IDLE,
    }),
  );
  dispatch(
    updateCommunicationStatus({
      actionType: actions.CREATE_BOOKING_COMMENT_CS,
      status: communicationStatus.IDLE,
    }),
  );
  dispatch(
    updateCommunicationStatus({
      actionType: actions.UPDATE_BOOKING_STATUS_CS,
      status: communicationStatus.IDLE,
    }),
  );
};

export const setLongtailBookingDetail = payload => ({
  type: actions.SET_LONGTAIL_BOOKING,
  payload,
});

export const getLongtailBookingDetail = params => dispatch => {
  fetch({
    endpoint: endpoints.graphql.url(),
    communicationType: actions.GET_LONGTAIL_BOOKING_CS,
    params: queries.getLongtailBookingDetail(
      formatSimpleParams(
        {
          referenceId: '',
        },
        params,
      ),
    ),
    dispatch,
    successAction: setLongtailBookingDetail,
  });
};
